

























import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class Mail extends Vue {
  @Prop({ default: '24' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: '#10222D' }) readonly color?: string;
}
